export default function About() {
  return (
    <section className="py-20 bg-[#2C3E50]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-6">
              Más de 30 años de experiencia como laboralistas y graduados sociales en Murcia
            </h2>
            <p className="text-white/80 mb-6 text-base leading-relaxed">
              El despacho <strong className="text-[#A77047]">Quereda y Murcia Abogados & Graduados Sociales</strong> nace fruto de la unión del <strong>graduado social y laboralista</strong> <strong className="text-[#A77047]">Alfonso Hernández Quereda</strong>, y del <strong>abogado laboral</strong> <strong className="text-[#A77047]">Adolfo Murcia Sala</strong>, ambos con una dilatada trayectoria profesional y más de 16.000 juicios realizados.
            </p>
            <p className="text-white/80 mb-6 text-base leading-relaxed">
              Consolidan con su unión un despacho multidisciplinar que cuenta con la colaboración de diversos especialistas en diferentes materias como son:
            </p>
            <ul className="space-y-3">
              <li className="flex items-center text-white/90">
                <i className="ri-checkbox-circle-fill text-[#A77047] text-xl mr-3"></i>
                <strong>Derecho Laboral</strong>
              </li>
              <li className="flex items-center text-white/90">
                <i className="ri-checkbox-circle-fill text-[#A77047] text-xl mr-3"></i>
                <strong>Graduados Sociales</strong>
              </li>
              <li className="flex items-center text-white/90">
                <i className="ri-checkbox-circle-fill text-[#A77047] text-xl mr-3"></i>
                <strong>Economistas</strong>
              </li>
            </ul>
            <p className="text-white/80 mt-6 text-base leading-relaxed">
              Además, mantienen una estrecha vinculación con organizaciones sindicales y asesorías de la Región de Murcia.
            </p>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/e86a6f0dbefd24b3e1189eb9e611dc93/75a66c180ad0a9f039805a36806eb1e5.jpeg"
                alt="Quereda y Murcia abogados laboralistas"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}